<template>
  <div>
    <div class="tags" :class="open===true ? 'on' : 'off'">
      <div class="tags_icon" @click="show"></div>
      <div class="tags_in">
        <div class="pad">
          <div class="tags_h1">点击复制 &nbsp; &nbsp;
            <label><input type="radio" v-model="copytype" value="en" /> 复制英文</label> &nbsp;
            <label><input type="radio" v-model="copytype" value="cn" /> 复制中文</label>
            <span v-show="tagstime!=''"> &nbsp; &nbsp; 词条更新时间：{{ tagstime }}</span>
            <span v-show="tagsonliner"> &nbsp; &nbsp; 在线人数：{{ tagsonliner }}</span>
          </div>
          <div class="inputdiv">
            <div class="h1"><input class="input" type="text" v-model="keywords" :placeholder="tagslist.length>0 ? '搜索中文或英文关键词' : '词条加载中...'" :disabled="tagslist.length==0" /></div>
            <div class="h2">
              <button @click="clearWords">清除</button>
              <button @click="randWords">抽卡</button>
              <button @click="presetsWords">预设</button>
            </div>
            <div class="clear"></div>
          </div>
          <div class="inputdiv2" v-show="ifrand">
            <div class="conlist_p conlist_p_all">
              <div class="in" @click="copyAll('all')" @contextmenu.prevent tabindex="1">
                <div>一键复制全部</div>
              </div>
            </div>
          </div>
          <div class="conlist">
            <div class="conlist_p" :class="'conlist_p_' + i" v-for="(item, i) in searlist" :key="'c' + i">
              <div class="in" @click="copy(i, item.cn, item.en)" @contextmenu.prevent tabindex="1">
                <div v-html="heilight(item.cn)"></div>
                <div v-html="(item.showtype==3 ? '' : heilight(item.en))" v-show="item.showtype!=3"></div>
              </div>
              <p v-show="ifrand" @click="deltag(i)">×</p>
            </div>

            <div class="nodata" v-show="searlist.length==0">
              暂无结果
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import Clipboard from 'clipboard';

export default {
  name: 'TagsSearch',
  data(){
    return {
      flag: false,
      open: false,
      keywords: '',
      apikey: '',
      tagslist: [],
      searlist: [],
      defaultlist: [],
      copytype: 'en',  //0=复制英文  1=复制中文
      ifrand: false,
      tagstime: '',
      tagsonliner: 0,
      csign: '',
      apiurl: 'http://www.ovsexia.com/',
      //apiurl: 'http://localhost/sakura2/',
    }
  },
  created(){
    let csign = localStorage.getItem('mantra_csign');
    if(csign){
      this.csign = csign;
    }
  },
  watch: {
    keywords(){
      if(this.keywords && this.keywords!=''){
        if(this.keywords.length==1 && ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'].includes(this.keywords.toLowerCase())){  //单个字母不搜索
          return false;
        }
        this.apiRequest(100, this.keywords);
      }else{
        this.searlist = this.defaultlist;
      }
    },
  },
  methods: {
    heilight(str){
      if(this.keywords){
        const arr = str.split(this.keywords);
        str = arr.join(`<span class="heilight">${this.keywords}</span>`)
      }
      return str;
    },
    show(){
      this.open = !this.open;
      if(this.flag===false){  //第一次开启
        this.flag = true;
        this.loadTag();
      }
    },
    searchIn(key, words){
      words = words.replace(/\(/g, '');
      words = words.replace(/\)/g, '');
      words = words.replace(/（/g, '');
      words = words.replace(/）/g, '');

      if(words.indexOf(key)!=-1){
        return 1;  //包含
      }else{
        return 0;  //不包含
      }
    },
    deltag(row){
      let searlistNew = [];
      for(let i = 0; i<this.searlist.length; i++){
        if(row!=i){
          searlistNew.push(this.searlist[i]);
        }
      }
      this.searlist = searlistNew;
    },
    apiRequest(limit=100, keywords='', changeField=['searlist'], ifrand=false){
      let that = this;
      if(that.apikey){
        that.apiRequestMsg(that.apikey, limit, keywords, changeField, ifrand);
      }else{
        const promise = that.apiRequestKey();
        promise.then(data => {
          if(data.data.status==1){
            that.apikey = data.data.key;
            that.apiRequestMsg(data.data.key, limit, keywords, changeField, ifrand);
          }else{
            console.log('error');
          }
        }).catch(error => {
          console.log(error);
        });
      }
    },
    apiRequestKey(){
      let that = this;
      return new Promise(function(resolve, reject){
        axios.post(that.apiurl + 'tags.php?act=getkey').then(function(data){
          if(!that.csign){
            that.csign = data.data.csign;
            localStorage.setItem('mantra_csign', data.data.csign);
          }
          resolve(data);
        }).catch(function(error){
          reject(error);
        });
      });
    },
    apiRequestMsg(key, limit=100, keywords='', changeField=[], ifrand){
      let that = this;
      axios.post(that.apiurl + 'tags.php?apikey=' + key + '&act=get_tags', qs.stringify({csign: that.csign, limit: limit, keywords: keywords})).then(function(res){
        if(res.data.status==1){
          for(let i=0; i<changeField.length; i++) {
            that[changeField[i]] = res.data.tagslist;
          }
          that.tagstime = res.data.tagstime;
          that.tagsonliner = res.data.tagsonliner;
          that.ifrand = ifrand ? true : false;
        }else if(res.data.status==-2){
          that.apikey = '';
          that.ifrand = ifrand ? true : false;
          that.apiRequest(limit, keywords, changeField, ifrand);
        }
      });
    },
    loadTag(){  //加载tags
      let that = this;
      that.apiRequest(100, '', ['tagslist', 'defaultlist', 'searlist']);
    },
    copy(id, textcn, texten){
      let that = this;
      new Clipboard('.conlist_p_' + id, {
        text: function() {
          return (that.copytype=='cn' ? textcn : texten);
        }
      });
    },
    copyAll(id){
      let that = this;
      if(!that.ifrand){
        return false;
      }
      let text = '';
      for(let i=0; i<this.searlist.length; i++) {
        text += (that.copytype=='cn' ? this.searlist[i]['cn'] : this.searlist[i]['en']) + ', ';
      }
      let last = text.slice(-2);
      if(last==', '){
        text = text.slice(0, -2);
      }
      new Clipboard('.conlist_p_'+id, {
        text: function() {
          return text;
        }
      });
    },
    clearWords(){
      this.keywords = '';
      this.ifrand = false;
    },
    randWords(){
      this.apiRequest(30, '__RANDOM__', ['searlist'], true);
    },
    presetsWords(){
      this.ifrand = false;
      this.apiRequest(100, '__PRESETS__');
    },
  },
}
</script>

<style>
.tags {position: fixed; z-index: 10; top: 22%; right: 0; transform: translateY(-50%); transform: translateX(100%);}
.tags.on {transform: translateX(0);}
.tags_icon {width: 54px; height: 54px; background-color: rgba(0, 0, 0, 0.8); border-radius: 6px 0 0 6px; cursor: pointer; position: absolute; top: 0; left: -54px;}
.tags_icon:before, .tags_icon:after {content: ""; display: block; position: absolute;}
.tags.off .tags_icon:before {width: 18px; height: 18px; border-radius: 50%; border: 2px solid #fff; top: 14px; left: 14px;}
.tags.off .tags_icon:after {width: 10px; height: 2px; background-color: #fff; transform: rotate(45deg); top: 36px; left: 30px;}
.tags.on .tags_icon:before, .tags.on .tags_icon:after {width: 28px; height: 2px; background-color: #fff; top: 26px; left: 13px;}
.tags.on .tags_icon:before {transform: rotate(45deg);}
.tags.on .tags_icon:after {transform: rotate(-45deg);}
.tags_in {width: 66vw; background-color: rgba(0, 0, 0, 0.8);}
.tags_in .pad {padding: 18px;}
.heilight {background-color: #e76b6b; padding: 0 2px;}
.input {border-radius: 5px; height: 38px; background-color: #f4f4f4; padding: 0 10px; box-sizing: border-box; border: 1px solid #ddd; font-size: 14px; width: 100%;}
.tags_h1 {font-size: 14px; color: #fff; padding-bottom: 8px;}
.conlist {height: 284px; overflow-x: hidden; overflow-y: auto; padding-top: 16px;}
.conlist::-webkit-scrollbar {width:6px;}
.conlist::-webkit-scrollbar-track {background-color:#f6f6f6; box-shadow:inset 0 0 8px rgba(0, 0, 0, 0.2); border-radius:12px;}
.conlist::-webkit-scrollbar-thumb {background-color:#7f7f7f; border-radius:12px;}
.conlist_p {display: inline-block; vertical-align: top; position: relative; margin-right: 8px; margin-bottom: 8px;}
.conlist_p .in {font-size: 14px; color: #fff; text-align: center; padding: 5px 12px; background-color: #3a97ef; border-radius: 8px; cursor: pointer; border: 2px solid #3a97ef; box-sizing: border-box;}
.conlist_p .in:hover {border-color: #22d844;}
.conlist_p .in:focus {background-color: #1962a6;}
.conlist_p_all .in {padding: 12px 12px; background-color: #19ba37; border-color: #22d844;}
.conlist_p_all .in:hover {border-color: #fff;}
.conlist_p_all .in:focus {background-color: #109729;}
.conlist_p .in div {height: 18px; line-height: 18px;}
.conlist_p p {width: 16px; height: 16px; line-height: 16px; font-size: 16px; text-align: center; color: #fff; background-color: #e76b6b; border-radius: 50%; position: absolute; opacity: 0; top: -5px; right: -5px; cursor: pointer;}
.conlist_p:hover p {opacity: 1;}
.conlist_p_all {margin-bottom: 0;}
.nodata {width: 100%; font-size: 20px; color: #fff; text-align: center; position: absolute; top: 50%; left: 0; transform: translateY(-50%);}
.inputdiv2 {margin-top: 15px;}
.inputdiv .h1 {float: left; width: calc(100% - 198px);}
.inputdiv .h2 {float: right; width: 198px;}
.inputdiv .h2 button {height: 38px; border: 0; color: #fff; padding: 0 10px; white-space: nowrap; min-width: 58px;}
.inputdiv .h2 button:nth-child(1) {background-color: #e76b6b; border-radius: 0 5px 5px 0;}
.inputdiv .h2 button:nth-child(2), .inputdiv .h2 button:nth-child(3) {background-color: #3a97ef; border-radius: 5px; margin-left: 10px;}
@media (max-width: 640px) {
  .tags_in {width: 80vw;}
}
</style>